const state = {
    userId: '',
    nickname: '',
    phone: '',
    email: '',
    realName: '',
    idCardNumber: '',
    gender: '',
    genderDesc: '',
    avatarUrl: '',
    userLevel: '',
    status: '',
    walletBalance: null,
    balanceStatus: 'loading' // loading, success, error
};

const mutations = {
    setUser(state, userInfo) {
        state.userId = userInfo.userId || '';
        state.nickname = userInfo.nickname || '';
        state.phone = userInfo.phone || '';
        state.email = userInfo.email || '';
        state.realName = userInfo.realName || '';
        state.idCardNumber = userInfo.idCardNumber || '';
        state.gender = userInfo.gender || '';
        state.genderDesc = userInfo.genderDesc || '';
        state.avatarUrl = userInfo.avatarUrl || '';
        state.userLevel = userInfo.userLevel || '';
        state.status = userInfo.status || '';
    },
    clearUser(state) {
        state.userId = '';
        state.nickname = '';
        state.phone = '';
        state.email = '';
        state.realName = '';
        state.idCardNumber = '';
        state.gender = '';
        state.avatarUrl = '';
        state.userLevel = '';
        state.status = '';
    },
    setWalletBalance(state, balance) {
        state.walletBalance = balance;
    },
    setBalanceStatus(state, status) {
        state.balanceStatus = status;
    },
};

const actions = {
    updateUserInfo({ commit }, userInfo) {
        commit('setUser', userInfo);
    },
    clearUserInfo({ commit }) {
        commit('clearUser');
    },
    async fetchWalletBalance({ commit, rootGetters }) {
        const getToken = rootGetters['auth/getToken'];
        if (!getToken) {
            commit('setWalletBalance', null);
            commit('setBalanceStatus', 'error');
            return;
        }

        commit('setBalanceStatus', 'loading');
        try {
            const { getAccountBalance } = await import('@/api/account');
            const data = await getAccountBalance();
            if (data.success === false) {
                console.error('获取用户余额失败:', data.message);
                commit('setWalletBalance', null);
                commit('setBalanceStatus', 'error');
                return;
            }
            commit('setWalletBalance', data.data || 0);
            commit('setBalanceStatus', 'success');
        } catch (error) {
            console.error('获取用户余额失败:', error);
            commit('setWalletBalance', null);
            commit('setBalanceStatus', 'error');
        }
    }
};

const getters = {
    getUserId(state) {
        return state.userId;
    },
    getNickname(state) {
        return state.nickname;
    },
    getPhone(state) {
        return state.phone;
    },
    getEmail(state) {
        return state.email;
    },
    getRealName(state) {
        return state.realName;
    },
    getIdCardNumber(state) {
        return state.idCardNumber;
    },
    getGender(state) {
        return state.gender;
    },
    getGenderDesc(state) {
        return state.genderDesc;
    },
    getAvatarUrl(state) {
        return state.avatarUrl;
    },
    getUserLevel(state) {
        return state.userLevel;
    },
    getStatus(state) {
        return state.status;
    },
    getWalletBalance(state) {
        return state.walletBalance;
    },
    getBalanceStatus(state) {
        return state.balanceStatus;
    },
    getCurrentUserInfo: (state) => {
        return {
            userId: state.userId,
            nickname: state.nickname,
            phone: state.phone,
            email: state.email,
            realName: state.realName,
            idCardNumber: state.idCardNumber,
            gender: state.gender,
            avatarUrl: state.avatarUrl,
            userLevel: state.userLevel,
            status: state.status,
        };
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
